import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhoneFlip, faHome, faLegal, faUserTie, faIdBadge } from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { SiteHeader } from "../../components/header/header";

import "../../styles/contact.css";

import MapEmbed from "../../components/cards/map-embed";
import { ContactForm } from "../../components/forms/contact-form";

export const ContactPage = () => {

    const navigateTo = useNavigate();
    const formRef = useRef();

    const project = useLocation()?.state?.project;

    useEffect(() => {
        formRef.current.scrollIntoView({ behavior: 'smooth', block: "start" })
    },[project])


    return (
        <div className="page-body flx-col">
            <SiteHeader
                title={"Kontakt"}
                navAction={() => {
                    navigateTo("/", { state: "service" })
                }}
            />
            <div className="app-body flx-col">
                <div className="upper-page">
                    <div className="service-call-container flx-rw c-al c-jt">
                        <span className="prim-dot" ></span>
                        <div className="service-text">
                            Schnelle Rückmeldung
                        </div>
                    </div>
                    <div className="page-title">
                        Kontakt
                    </div>
                    <div className="title-context">
                        Wir melden uns innerhalb von 2 Stunden zurück – kostenlose Beratung und Besichtigung in Berlin.
                    </div>
                </div>
                <div className="address-column flx-col">
                    <div className="addr-caption">Unsere physische Adresse</div>
                    <div className="phy-addr-list flx-col">
                        <div className="phy-list-item">
                            <FontAwesomeIcon icon={faUserTie} className="phy-icon" />
                            <span className="phy-caption">ACT-Umzugs & Reinigungs UG (haftungsbeschränkt)</span>
                        </div>
                        <div className="phy-list-item">
                            <FontAwesomeIcon icon={faHome} className="phy-icon" />
                            <span className="phy-caption">12329 Berlin</span>
                        </div>
                        <div className="phy-list-item">
                            <FontAwesomeIcon icon={faLegal} className="phy-icon" />
                            <span className="phy-caption">
                                Registergericht: Amtsgetritch Charlottenburg HRB 257062 B
                            </span>
                        </div>
                        <div className="phy-list-item">
                            <FontAwesomeIcon icon={faIdBadge} className="phy-icon" />
                            <span className="phy-caption">USTID DE363532456</span>
                        </div>

                    </div>
                </div>
                <div className="contact-section">
                    <div className="flx-col">
                        <button
                            className="contact-wht-btn flx-rw c-al sh-bx"
                            onClick={() => window.location.href = "tel:+4917622006681"}
                        >
                            <div className="icon-button flx-col c-al c-jt call">
                                <FontAwesomeIcon icon={faPhoneFlip} />
                            </div>

                            <div
                                className="flx-col info-bx"

                            >
                                <div className="info-cap">Telephon</div>
                                <div className="call-info">+4917622006681</div>
                            </div>

                        </button>
                        <button
                            className="contact-wht-btn flx-rw c-al  sh-bx"
                            onClick={() => window.location.href = "https://wa.me/+4917622006681"}
                        >
                            <div className="icon-button flx-col c-al c-jt wht">
                                <FontAwesomeIcon icon={faWhatsapp} />
                            </div>
                            <div className="flx-col info-bx">
                                <div className="info-cap">WhatsApp</div>
                                <div className="wht-info">Schnell Antwort</div>
                            </div>
                        </button>
                        <button className="contact-wht-btn sh-bx flx-col">
                            <div className="flx-col info-bx">
                                <div className="info-cap">Address</div>
                                <div className="addr-info">Brigitte Reimann Str. 27, Berlin</div>
                            </div>
                            <MapEmbed />
                        </button>
                    </div>
                    <div ref={formRef} style={{scrollMarginTop: 120}}></div>
                    <ContactForm />
                </div>
            </div>
        </div>
    );
}